import styled from 'styled-components';
import device, { pageMaxWidth } from '../../mediaQueries';

const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  z-index: 6;
  width: 100%;
  background-color: #ffffff;
  padding: 0 15px 0;
  height: 50px;

  ${device.desktop`
    height: 165px;
    padding: 12px 20px 0;
    width: 100%;
 `}
  ${device.largeDesktop`
    padding: 12px 0 0;
 `}

  & > div {
    margin: 0 auto;
    max-width: ${pageMaxWidth};
  }
`;

export default HeaderWrapper;
